import { NoDataFound } from "@/components/NoDataFound";
import { Spinner } from "@/components/Spinner";
import NewsTeaserDisplay from "@/components/news/NewsTeaserDisplay";
import { useArticles } from "@/lib/api";
import Error from "next/error";

export const NewsTeaser = ({
  category = null,
  linkToCategory = false,
  newsToExclude,
}) => {
  const { articles, isLoading, isError } = useArticles(category, 4);

  if (isLoading) return <Spinner />;
  if (isError) return <Error />;

  if (articles.length === 0) {
    return <NoDataFound type="News" />;
  }

  return (
    <NewsTeaserDisplay
      articles={articles.articles}
      linkToCategory={category?.id}
      newsToExclude={newsToExclude}
    />
  );
};
